<template>

  <section :id="sectionId" class="games-section slot-games-section">

    <div class="section-header slot-games-section__header">

      <div class="section-header__title slot-games-section__title-row">

        <button

          v-if="showBack"

          type="button"

          class="slot-games-section__back"

          @click="$emit('back')"

        >

          ‹

        </button>

        <div>

          <h2>{{ title || providerName || $t('games.list') }}</h2>

          <p v-if="gameCountLabel" class="slot-games-section__count">{{ gameCountLabel }}</p>

        </div>

      </div>

    </div>

    <div class="slot-games-section__search">

      <input

        v-model.trim="searchQuery"

        type="search"

        class="slot-games-section__search-input"

        :placeholder="$t('games.search')"

        autocomplete="off"

      >

    </div>

    <p v-if="loading" class="games-section__status">{{ $t('games.loading') }}</p>

    <p v-else-if="loadError" class="games-section__status games-section__status--error">{{ loadError }}</p>

    <p v-else-if="!filteredGames.length" class="games-section__status">

      {{ searchQuery ? $t('games.emptySearch') : $t('games.empty') }}

    </p>

    <div v-else class="slot-games-grid">

      <article

        v-for="game in filteredGames"

        :key="`${game.provider}-${game.code}`"

        class="game-card slot-game-card"

        @click="$emit('preview', game)"

      >

        <div class="game-card__thumb">

          <span v-if="game.is_hot" class="game-card__badge game-card__badge--hot">HOT</span>

          <img

            :src="game.image || fallbackImg"

            :alt="game.name"

            loading="lazy"

            @error="onImgError($event)"

          >

          <div class="game-card__play">

            <i class="fas fa-circle-play" aria-hidden="true" />

          </div>

        </div>

        <div class="game-info">

          <strong>{{ game.name }}</strong>

          <span v-if="game.provider_name">{{ game.provider_name }}</span>

        </div>

      </article>

    </div>

  </section>

</template>

<script>

import { normalizeSlotGames } from '@/utils/game'

const FALLBACK_IMG = 'data:image/svg+xml,' + encodeURIComponent(

  '<svg xmlns="http://www.w3.org/2000/svg" width="216" height="160" viewBox="0 0 216 160">' +

  '<rect width="216" height="160" fill="#151515"/>' +

  '<text x="108" y="84" fill="#666" font-size="14" text-anchor="middle" font-family="sans-serif">No Image</text>' +

  '</svg>'

)

export default {

  name: 'BlackGoldSlotGames',

  props: {

    sectionId: {

      type: String,

      default: 'section-slots-games'

    },

    title: {

      type: String,

      default: ''

    },

    showBack: {

      type: Boolean,

      default: true

    },

    providerName: {

      type: String,

      default: ''

    },

    games: {

      type: Array,

      default: () => []

    },

    loading: {

      type: Boolean,

      default: false

    },

    loadError: {

      type: String,

      default: ''

    }

  },

  data () {
    return {

      fallbackImg: FALLBACK_IMG,

      searchQuery: ''

    }
  },

  computed: {

    normalizedGames () {
      return normalizeSlotGames(this.games)
    },

    filteredGames () {
      const q = String(this.searchQuery || '').trim().toLowerCase()

      if (!q) return this.normalizedGames

      return this.normalizedGames.filter(game => {
        const name = String(game.name || '').toLowerCase()

        const code = String(game.code || '').toLowerCase()

        return name.includes(q) || code.includes(q)
      })
    },

    gameCountLabel () {
      if (this.loading || this.loadError) return ''

      const total = this.normalizedGames.length

      if (!total) return ''

      const shown = this.filteredGames.length

      if (this.searchQuery && shown !== total) {
        return this.$t('games.gameCountFiltered', { shown, total })
      }

      return this.$t('games.gameCountTotal', { total })
    }

  },

  watch: {

    providerName () {
      this.searchQuery = ''
    }

  },

  methods: {

    onImgError (event) {
      if (event && event.target) {
        event.target.src = this.fallbackImg
      }
    }

  }

}

</script>
